module.exports = __webpack_public_path__ + "img/A3.9d838faa.png";